"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deck = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Deck = require("./Deck.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Deck = function Deck(props) {
  var children = props.children;
  return _react.default.createElement(_Deck.StyledDeck, props, children);
};
/**
 * Definition of default values for component props
 */


exports.Deck = Deck;
Deck.defaultProps = {
  width: undefined,
  className: undefined,
  id: undefined,
  shadow: undefined
};
/**
 * Definition of types for component props
 */

Deck.propTypes = {
  /** Collection of items in the deck. Must be a collection of Cards */
  children: _propTypes.default.node.isRequired,

  /** The CSS width property for the deck */
  width: _propTypes.default.string,

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string,

  /** The shadow strength */
  shadow: _propTypes.default.oneOf(['shadow300', 'shadow500', 'shadow700', undefined])
};